import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   max-width: 480px;
   width: 100%;
   display: flex;
   flex-direction: column;
   gap: 12px;

   .section {
      display: flex;
      flex-direction: column;
      gap: 8px;
   }

   .label {
      color: #1f2937;
      font-size: 14px;
      font-weight: 600;
   }

   .modeRow,
   .directionRow {
      display: flex;
      flex-direction: column;
      gap: 8px;
   }

   .modeRow label,
   .directionRow label,
   .toggleRow {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #333;
      font-size: 13px;
   }

   .helper-text {
      color: #555;
      font-size: 12px;
      line-height: 1.4;
   }

   .sectionError {
      color: #b42318;
      font-size: 12px;
      line-height: 1.4;
   }

   .webhook-section h4 {
      margin: 0 0 6px 0;
      color: #333;
      font-size: 15px;
      font-weight: 600;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: Monaco, Menlo, "Ubuntu Mono", monospace;
      font-size: 13px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      min-width: 0;
      flex: 1;
   }

   .hint {
      margin: 0;
      color: #555;
      font-size: 13px;
      line-height: 1.4;
   }
`;
